/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddPromotionCustomersRequest,
  CreatePromotion201Response,
  CreatePromotionRequest,
  GetOrganizationPoints200Response,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  GetPromotionCustomerCandidates200Response,
  GetPromotions200Response,
  UpdateAutomaticPromotionRequest,
  UpdateCurrencyPointsRequest,
  UpdateLocationComboRequest,
  UpdateTabPointsRequest,
} from '../models/index';
import {
    AddPromotionCustomersRequestFromJSON,
    AddPromotionCustomersRequestToJSON,
    CreatePromotion201ResponseFromJSON,
    CreatePromotion201ResponseToJSON,
    CreatePromotionRequestFromJSON,
    CreatePromotionRequestToJSON,
    GetOrganizationPoints200ResponseFromJSON,
    GetOrganizationPoints200ResponseToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    GetPromotionCustomerCandidates200ResponseFromJSON,
    GetPromotionCustomerCandidates200ResponseToJSON,
    GetPromotions200ResponseFromJSON,
    GetPromotions200ResponseToJSON,
    UpdateAutomaticPromotionRequestFromJSON,
    UpdateAutomaticPromotionRequestToJSON,
    UpdateCurrencyPointsRequestFromJSON,
    UpdateCurrencyPointsRequestToJSON,
    UpdateLocationComboRequestFromJSON,
    UpdateLocationComboRequestToJSON,
    UpdateTabPointsRequestFromJSON,
    UpdateTabPointsRequestToJSON,
} from '../models/index';

export interface AddPromotionCustomersOperationRequest {
    promotionId: string;
    addPromotionCustomersRequest: AddPromotionCustomersRequest;
}

export interface CreatePromotionOperationRequest {
    createPromotionRequest: CreatePromotionRequest;
}

export interface DeletePromotionRequest {
    promotionId: string;
}

export interface DeletePromotionCustomersRequest {
    promotionId: string;
    addPromotionCustomersRequest: AddPromotionCustomersRequest;
}

export interface GetPromotionByIdRequest {
    promotionId: string;
}

export interface GetPromotionCustomerCandidatesRequest {
    promotionId: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetPromotionCustomersRequest {
    promotionId: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetPromotionsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface UpdateAutomaticPromotionOperationRequest {
    updateAutomaticPromotionRequest: UpdateAutomaticPromotionRequest;
}

export interface UpdateCurrencyPointsOperationRequest {
    updateCurrencyPointsRequest: UpdateCurrencyPointsRequest;
}

export interface UpdatePromotionRequest {
    promotionId: string;
    createPromotionRequest: CreatePromotionRequest;
}

export interface UpdatePromotionStatusRequest {
    promotionId: string;
    updateLocationComboRequest: UpdateLocationComboRequest;
}

export interface UpdateTabPointsOperationRequest {
    updateTabPointsRequest: UpdateTabPointsRequest;
}

/**
 * 
 */
export class PromotionsApi extends runtime.BaseAPI {

    /**
     */
    async addPromotionCustomersRaw(requestParameters: AddPromotionCustomersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling addPromotionCustomers().'
            );
        }

        if (requestParameters['addPromotionCustomersRequest'] == null) {
            throw new runtime.RequiredError(
                'addPromotionCustomersRequest',
                'Required parameter "addPromotionCustomersRequest" was null or undefined when calling addPromotionCustomers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{promotionId}/customers`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddPromotionCustomersRequestToJSON(requestParameters['addPromotionCustomersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addPromotionCustomers(requestParameters: AddPromotionCustomersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addPromotionCustomersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createPromotionRaw(requestParameters: CreatePromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePromotion201Response>> {
        if (requestParameters['createPromotionRequest'] == null) {
            throw new runtime.RequiredError(
                'createPromotionRequest',
                'Required parameter "createPromotionRequest" was null or undefined when calling createPromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePromotionRequestToJSON(requestParameters['createPromotionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePromotion201ResponseFromJSON(jsonValue));
    }

    /**
     */
    async createPromotion(requestParameters: CreatePromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePromotion201Response> {
        const response = await this.createPromotionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deletePromotionRaw(requestParameters: DeletePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling deletePromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePromotion(requestParameters: DeletePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePromotionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deletePromotionCustomersRaw(requestParameters: DeletePromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling deletePromotionCustomers().'
            );
        }

        if (requestParameters['addPromotionCustomersRequest'] == null) {
            throw new runtime.RequiredError(
                'addPromotionCustomersRequest',
                'Required parameter "addPromotionCustomersRequest" was null or undefined when calling deletePromotionCustomers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{promotionId}/customers`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: AddPromotionCustomersRequestToJSON(requestParameters['addPromotionCustomersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePromotionCustomers(requestParameters: DeletePromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePromotionCustomersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getOrganizationPointsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationPoints200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/organization-points`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationPoints200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationPoints(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationPoints200Response> {
        const response = await this.getOrganizationPointsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPromotionByIdRaw(requestParameters: GetPromotionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePromotionRequest>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getPromotionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePromotionRequestFromJSON(jsonValue));
    }

    /**
     */
    async getPromotionById(requestParameters: GetPromotionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePromotionRequest> {
        const response = await this.getPromotionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPromotionCustomerCandidatesRaw(requestParameters: GetPromotionCustomerCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromotionCustomerCandidates200Response>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getPromotionCustomerCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}/customer/candidates`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromotionCustomerCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPromotionCustomerCandidates(requestParameters: GetPromotionCustomerCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromotionCustomerCandidates200Response> {
        const response = await this.getPromotionCustomerCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPromotionCustomersRaw(requestParameters: GetPromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromotionCustomerCandidates200Response>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getPromotionCustomers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{promotionId}/customers`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromotionCustomerCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPromotionCustomers(requestParameters: GetPromotionCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromotionCustomerCandidates200Response> {
        const response = await this.getPromotionCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPromotionsRaw(requestParameters: GetPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromotions200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromotions200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPromotions(requestParameters: GetPromotionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromotions200Response> {
        const response = await this.getPromotionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAutomaticPromotionRaw(requestParameters: UpdateAutomaticPromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateAutomaticPromotionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAutomaticPromotionRequest',
                'Required parameter "updateAutomaticPromotionRequest" was null or undefined when calling updateAutomaticPromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/automatic-promotion`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAutomaticPromotionRequestToJSON(requestParameters['updateAutomaticPromotionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAutomaticPromotion(requestParameters: UpdateAutomaticPromotionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAutomaticPromotionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCurrencyPointsRaw(requestParameters: UpdateCurrencyPointsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateCurrencyPointsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCurrencyPointsRequest',
                'Required parameter "updateCurrencyPointsRequest" was null or undefined when calling updateCurrencyPoints().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/currency-points`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCurrencyPointsRequestToJSON(requestParameters['updateCurrencyPointsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCurrencyPoints(requestParameters: UpdateCurrencyPointsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCurrencyPointsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updatePromotionRaw(requestParameters: UpdatePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling updatePromotion().'
            );
        }

        if (requestParameters['createPromotionRequest'] == null) {
            throw new runtime.RequiredError(
                'createPromotionRequest',
                'Required parameter "createPromotionRequest" was null or undefined when calling updatePromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{promotionId}`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePromotionRequestToJSON(requestParameters['createPromotionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePromotion(requestParameters: UpdatePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePromotionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updatePromotionStatusRaw(requestParameters: UpdatePromotionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling updatePromotionStatus().'
            );
        }

        if (requestParameters['updateLocationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationComboRequest',
                'Required parameter "updateLocationComboRequest" was null or undefined when calling updatePromotionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{promotionId}`.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationComboRequestToJSON(requestParameters['updateLocationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePromotionStatus(requestParameters: UpdatePromotionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePromotionStatusRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateTabPointsRaw(requestParameters: UpdateTabPointsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateTabPointsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTabPointsRequest',
                'Required parameter "updateTabPointsRequest" was null or undefined when calling updateTabPoints().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/tab-points`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTabPointsRequestToJSON(requestParameters['updateTabPointsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTabPoints(requestParameters: UpdateTabPointsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTabPointsRaw(requestParameters, initOverrides);
    }

}
